import * as CALReportConstants from "./ChemCalReportConstants";


/**
 * initial state which is managed by ISEParserReducer
 */
const initialState = {
  isLoading: false,
  reports: [],
  error: null,
};

/**'
 * redux reducer method which takes the current state and the action as input parameters and returns with the new state
 */
export default function ChemCalReportReducer(state = initialState, action) {

  switch (action.type) {
    case CALReportConstants.FETCH_CAL_REPORT_INFO_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: "",
        isError: false
      };
    case CALReportConstants.FETCH_CAL_REPORT_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        reports: action.payload?.result?.calibrationData,
        supplies: action.payload?.result?.supplies,
        mathModel:action.payload?.result?.mathModel,
        rbData:action.payload?.result?.rbDataPoints,
        chemLevelInfoPoints:action.payload?.result?.chemLevelInfoPoints,
        error: "",
        isError: false
      };
    case CALReportConstants.FETCH_CAl_REPORT_DATA_FAILURE:
      return {
        ...state,
        reports: [],
        isLoading: false,
        error: action.payload,
        isError: true
      };

   

    default:
      return state;
  }
}
